import api from "./config/axios.config";

export type ActivationMode = "create" | "reset";

export const validateActivationCode = async (
  code: string,
  token: string,
  _mode?: ActivationMode
): Promise<void> => {
  // Verificación de código para cambio de contraseña (reset)
  await api.request({
    url: "/sendMail/v2/reset-password/validate",
    method: "post",
    data: { codigoVerificacion: code },
    headers: { "x-verification-token": token },
  });
};

export const validateCreateActivationCode = async (
  code: string,
  token: string
): Promise<void> => {
  // Verificación de código para creación (endpoint de creación)
  await api.request({
    url: "/sendMail/v2/activate/validate",
    method: "post",
    data: { codigoVerificacion: code },
    headers: { "x-verification-token": token },
  });
};

const activationService = { validateActivationCode, validateCreateActivationCode };
export default activationService;
